import ModalWizard from './modal_wizard'
import { connect } from 'react-redux'

import { fromMobileSelector } from 'redux/selectors/mobile'

export const mapStateToProps = (state, { hideBack, hideClose }) => {
  const fromMobile = fromMobileSelector()(state)
  let hideTopWithoutHeader = false
  if (fromMobile) {
    hideBack = true
    hideClose = true
    hideTopWithoutHeader = true
  }

  return { hideBack, hideClose, hideTopWithoutHeader }
}

export default connect(mapStateToProps)(ModalWizard)
